<template>
  <div>
    <div class="full-page" v-if="multiPdf">
      <b-icon-x style="z-index: 1000; position: relative;" class="close-icon" @click="closePage('multiPdf')"></b-icon-x>
      <div class="container-fluid">
        <h3>Multi PDF</h3>

        <b-button class="mb-1 mr-1" style="float: left;" size="sm" @click="createPdf">Download PDF</b-button>
        <b-button class="mb-1 mr-1" style="float: left;" size="sm" @click="createPNG">Download PNG</b-button>
        <b-button class="mb-1 mr-1" style="float: left;" size="sm" @click="showSettings = !showSettings">PDF Settings</b-button>

        <div id="svg-multi-pdf" class="container">
          <svg id="svg-multi" class="pdf-page" :viewBox="`0 0 ${700} ${989}`">
            <!-- svg logo -->
            <g transform="scale(0.26)translate(58,58)">
              <path :d="svgLogo.logoPath1" style="fill:#2fade2"></path>
              <path :d="svgLogo.logoPath2" style="fill:#2c2840"></path>
            </g>

            <!-- header info -->
            <text style="font: bold 8px sans-serif;" :x="col1 + 10" :y="rows(1)">Name:</text>
            <text style="font: 8px sans-serif;" :x="col2 + 10" :y="rows(1)">{{ currentInfo.businessName }}</text>

            <text style="font: bold 8px sans-serif;" :x="col1 + 10" :y="rows(2)">Address:</text>
            <text style="font: 8px sans-serif;" :x="col2 + 10" :y="rows(2)">{{ currentInfo.street }}</text>
            <text style="font: 8px sans-serif;" :x="col1 + 10" :y="rows(3)">
              {{ `${currentInfo.city || ""} ${currentInfo.state || ""} ${currentInfo.postalCode || ""}` }}
            </text>

            <!-- set title info  -->
            <text style="font: 7px sans-serif;" :x="275" :y="rows(i + 2)" v-for="(set, i) of currentSets" :key="i">
              {{ `${i + 1} : ${infoFromSet(set)}` }}
            </text>
            <g v-if="showMoon">
              <g
                :transform="`scale(.07)translate(3760,${380 + i * 150})`"
                v-for="(set, i) of currentSets"
                :key="`${i}-moon`"
                v-html="moonIcon(set).icon"
              ></g>
            </g>

            <!-- legend -->
            <SvgLegend :x="520" :y="28" />

            <!-- header -->
            <rect x="18" y="70" width="660" height="14" fill="#0E7FAD" />
            <text style="font: bold 8px sans-serif;" fill="white" x="20" y="80">Element</text>
            <text style="font: bold 7px sans-serif;" fill="white" x="112" y="80" text-anchor="middle">Optimum</text>
            <text style="font: bold 7px sans-serif;" fill="white" :x="unitsCol" y="80" text-anchor="middle">Units</text>
            <text style="font: bold 7px sans-serif;" fill="white" :x="innerCol1" y="80" text-anchor="middle">Young</text>
            <text style="font: bold 7px sans-serif;" fill="white" :x="innerCol2" y="80" text-anchor="middle">Old</text>

            <!-- elements -->
            <g v-for="(elmt, i) of activeElements" :key="elmt.key" :transform="`translate(0,${graphRows(i)})`">
              <text style="font: bold 8px sans-serif;" x="20" y="28">{{ elmt.label }}</text>
              <!-- ranges -->
              <rect :x="ranges(elmt.key).highl" y="10" :width="ranges(elmt.key).highh" height="34" fill="#e6f1fd" />
              <rect :x="ranges(elmt.key).okl" y="10" :width="ranges(elmt.key).okh" height="34" fill="#c5e1ff" />

              <g v-for="(val, i) of elementValues(elmt.key)" :key="val.id">
                <rect
                  v-if="colorVals"
                  :x="innerCol1 - 15"
                  :y="12 + i * computedHeight.row"
                  width="28"
                  :height="computedHeight.row - 1"
                  :fill="val.realColory"
                />
                <rect
                  v-if="colorVals"
                  :x="innerCol2 - 15"
                  :y="12 + i * computedHeight.row"
                  width="28"
                  :height="computedHeight.row - 1"
                  :fill="val.realColoro"
                />

                <text style="font: 6.5px sans-serif;" text-anchor="middle" :x="innerCol1" :y="18 + i * computedHeight.row + (computedHeight.bar - 3)">
                  {{ val.young }}
                </text>
                <text style="font: 6.5px sans-serif;" text-anchor="middle" :x="innerCol2" :y="18 + i * computedHeight.row + (computedHeight.bar - 3)">
                  {{ val.old }}
                </text>
                <text style="font: 7px sans-serif;" text-anchor="middle" :x="unitsCol" :y="18 + i * computedHeight.row + (computedHeight.bar - 3)">
                  {{ val.units }}
                </text>
                <text style="font: 5px sans-serif;" x="270" :y="17 + i * computedHeight.row + (computedHeight.bar - 3)">{{ i + 1 }}</text>

                <!-- over lap bars with the smallest value always being the lower bar on top of the larger value -->
                <g v-if="val.youngy >= val.oldy">
                  <rect :x="val.start" :y="12 + i * computedHeight.row" :width="val.youngy" :height="computedHeight.bar" :fill="val.colory" />
                  <rect
                    :x="val.starto || val.start"
                    :y="15 + (i * computedHeight.row - computedHeight.bar * 0.35) + (computedHeight.bar - 3)"
                    :width="val.oldy"
                    :height="computedHeight.bar"
                    :fill="val.coloro"
                  />
                </g>

                <g v-if="val.youngy < val.oldy">
                  <rect
                    :x="val.starto || val.start"
                    :y="12 + i * computedHeight.row"
                    :width="val.oldy"
                    :height="computedHeight.bar"
                    :fill="val.coloro"
                  />
                  <!-- Yeah I know this is crazy... -->
                  <rect
                    :x="val.start"
                    :y="15 + (i * computedHeight.row - computedHeight.bar * 0.35) + (computedHeight.bar - 3)"
                    :width="val.youngy"
                    :height="computedHeight.bar"
                    :fill="val.colory"
                  />
                </g>
              </g>

              <text style="font: 7px sans-serif;" text-anchor="middle" x="112" y="28">{{ elementRange(elmt.key) }}</text>

              <line x1="278" x2="278" y1="10" y2="45" style="stroke:black;stroke-width:.75" />
              <line x1="678" x2="678" y1="10" y2="45" style="stroke:black;stroke-width:.75" />

              <!-- divider lines -->
              <line x1="18" x2="678" y1="45" y2="45" style="stroke:#888;stroke-width:.5" />
              <line x1="18" x2="678" y1="47" y2="47" style="stroke:#888;stroke-width:.5" />
            </g>

            <text
              v-for="ann of annotations"
              :key="ann.id"
              class="draggable"
              :style="`font: ${ann.fontSize}px sans-serif;`"
              :fill="ann.color"
              x="180"
              y="180"
            >
              {{ ann.text }}
            </text>

             <!-- disclaimer  -->
             <PdfDisclaimer :x="18" :y="962"/>
          </svg>
        </div>

        <div style="padding: 4em;"></div>

        <div class="pdf-sidebar-outer" v-show="showSettings">
          <div class="pdf-sidebar">
            <div class="pdf-inner">
              <b-icon-chevron-right class="close-settings-icon" @click="showSettings = false"></b-icon-chevron-right>

              <h3>PDF Settings</h3>
              <b-form style="text-align: left;">
                <b-form-group label="Select Type of PDF:">
                  <b-form-radio-group stacked v-model="pdfType" :options="options"></b-form-radio-group>
                </b-form-group>

                <b-form-group>
                  <b-form-checkbox v-model="colorVals" switch>Color Values</b-form-checkbox>
                </b-form-group>

                <b-form-group>
                  <b-form-checkbox v-model="showMoon" switch>Show Moonphase</b-form-checkbox>
                </b-form-group>

                <PDFAnnotations name="multi-pdf" />

                <div class="mt-4"></div>

                <b-button v-show="orderHasChanged" size="sm" @click="resetOrder"> Reset </b-button>

                <draggable v-model="elementList" @start="drag = true" @end="drag = false" v-bind="dragOptions" group="elements">
                  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div class="list-item" v-for="elmt of elementList" :key="elmt.id">
                      <b-form-checkbox v-model="elmt.active">{{ elmt.label }}</b-form-checkbox>
                    </div>
                  </transition-group>
                </draggable>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Alert />
  </div>
</template>

<script>
import { scaleLinear } from "d3";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { logoPath1, logoPath2 } from "../assets/images/CHLlogo";
import draggable from "vuedraggable";
import { pdf } from "../modules/api";
import { selectColor } from "../modules/colors";
import { dynamicSortDate, randomId, dynamicSortNumber, downloadSvg, makeDraggableSvg } from "../modules/utils";
import SvgLegend from "../components/SvgLegend";
import PdfDisclaimer from "./PdfDisclaimer.vue";
import Alert from "../components/Alert";
import PDFAnnotations from "./PDFAnnotations.vue";
import { EventBus } from "../modules/eventBus";
import { lunarPhaseAndIcon } from "../modules/moonphase";

export default {
  name: "multi-pdf",
  props: {
    // currentRecord: String
  },
  data() {
    return {
      col1: 100,
      col2: 150,
      col3: 310,
      col4: 420,
      elements: [
        { id: 1, active: true, key: "sugar", label: "Total Sugars" },
        { id: 2, active: true, key: "pH", label: "pH" },
        { id: 3, active: true, key: "EC", label: "EC" },
        { id: 4, active: true, key: "potassium", label: "Potassium" },
        { id: 5, active: true, key: "calcium", label: "Calcium" },
        { id: 6, active: true, key: "magnesium", label: "Magnesium" },
        { id: 7, active: true, key: "sodium", label: "Sodium" },
        { id: 8, active: true, key: "ammonium", label: "Ammonium" },
        { id: 9, active: true, key: "NO3_nitrate", label: "Nitrate" },
        { id: 10, active: true, key: "nitrogen_in_nitrate", label: "N in Nitrate" },
        { id: 11, active: true, key: "nitrogen", label: "Total Nitrogen" },
        { id: 12, active: true, key: "chloride", label: "Chloride" },
        { id: 13, active: true, key: "sulfur", label: "Sulfur" },
        { id: 14, active: true, key: "phosphorous", label: "Phosphorus" },
        { id: 15, active: true, key: "silica", label: "Silica" },
        { id: 16, active: true, key: "iron", label: "Iron" },
        { id: 17, active: true, key: "manganese", label: "Manganese" },
        { id: 18, active: true, key: "zinc", label: "Zinc" },
        { id: 19, active: true, key: "boron", label: "Boron" },
        { id: 20, active: true, key: "copper", label: "Copper" },
        { id: 21, active: true, key: "molybdenum", label: "Molybdenum" },
        { id: 23, active: true, key: "cobalt", label: "Cobalt" },
        { id: 22, active: true, key: "aluminium", label: "Aluminium" },
      ],
      showSettings: false,
      drag: false,
      showMoon: false,
      orderHasChanged: false,
      pdfType: "regular simple",
      options: [
        { text: "AEA Regular Bars", value: "regular simple" },
        { text: "AEA Regular Bars Color", value: "regular muted" },
        { text: "AEA Centerline Bars", value: "center simple" },
        { text: "AEA Centerline Bars Color", value: "center muted" },
      ],
      colorVals: true,
      unitsCol: 156,
      innerCol1: 200,
      innerCol2: 240,
      annotations: [],
    };
  },
  methods: {
    async createPdf() {
      let svg = document.getElementById("svg-multi-pdf").innerHTML;

      let res = await pdf.createLinePdf({ svgs: [svg] });

      const blob = new Blob([res.data], { type: "application/pdf" });

      // process to auto download it
      const fileURL = URL.createObjectURL(blob);
      const link = document.createElement("a");
      document.body.append(link);
      link.href = fileURL;
      link.download = `${this.currentInfo.businessName}-${this.currentInfo.locationName}-${
        this.currentInfo.plotName
      }-${new Date().toISOString().slice(0, 10)}.pdf`;
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(fileURL);
        document.body.removeChild(link);
      }, 100);
    },

    async createPNG() {
      this.showMoon = false;
      await this.$nextTick();
      let fileName = `${this.currentInfo.businessName}-${this.currentInfo.locationName}-${this.currentInfo.plotName}-${new Date()
        .toISOString()
        .slice(0, 10)}.png`;
      let svg = document.getElementById("svg-multi-pdf");
      downloadSvg(svg.firstChild, fileName);
    },

    ranges(element) {
      let { y, range } = this.scaleAndData(element);
      let margin = 278;

      if (this.pdfBarType === "regular") {
        return {
          okl: y(range["Ok Low"]) + margin,
          okh: y(range["Ok High"]) - y(range["Ok Low"]),
          highl: y(range["Very Low"]) + margin,
          highh: y(range["Very High"]) - y(range["Very Low"]),
          perfect: y(range["Perfect"]) + margin,
        };
      } else {
        return {
          okl: 200 + margin - y(range.Perfect) + y(range["Ok Low"]),
          okh: y(range["Ok High"] - range["Ok Low"]),
          highl: 200 + margin - y(range.Perfect) + y(range["Very Low"]),
          highh: y(range["Very High"] - range["Very Low"]),
          perfect: margin + 200,
        };
      }
    },

    elementValues(element) {
      let { y, data, range } = this.scaleAndData(element);
      const perfect = range.Perfect;
      let colorBook = this.pdfType.split(" ")[1];
      const margin = 278;

      if (this.pdfBarType === "regular") {
        return data.map(x => ({
          ...x,
          id: randomId(),
          oldy: y(x.old),
          youngy: y(x.young),
          start: y(0) + margin,
          colory: selectColor(x.young, range, "young", colorBook),
          coloro: selectColor(x.old, range, "old", colorBook),
          realColory: selectColor(x.young, range, "young", "muted"),
          realColoro: selectColor(x.old, range, "young", "muted"),
        }));
      } else {
        return data.map(x => {
          let innerY,
            innerYo,
            start,
            starto = null;
          if (x.young > perfect) {
            innerY = y(x.young) - y(perfect);
            start = 200.5 + margin;
          } else {
            innerY = y(perfect) - y(x.young);
            start = 199.5 + margin - y(perfect) + y(x.young);
          }

          if (x.old > perfect) {
            innerYo = y(x.old) - y(perfect);
            starto = 200.5 + margin;
          } else {
            innerYo = y(perfect) - y(x.old);
            starto = 199.5 + margin - y(perfect) + y(x.old);
          }

          return {
            ...x,
            youngy: innerY,
            oldy: innerYo,
            start,
            starto,
            colory: selectColor(x.young, range, "young", colorBook),
            coloro: selectColor(x.old, range, "old", colorBook),
            realColory: selectColor(x.young, range, "young", "muted"),
            realColoro: selectColor(x.old, range, "young", "muted"),
          };
        });
      }
    },

    elementRange(element) {
      let range = this.currentSeriesRange(element);
      if (!range["Ok Low"] || !range["Ok High"]) {
        return "";
      }
      return `${range["Ok Low"]} - ${range["Ok High"]}`;
    },

    youngOldSet(tests) {
      let young = tests.find(x => x.plantPart.includes("young"));
      let old = tests.find(x => x.plantPart.includes("old"));
      if (!young) {
        young = { values: [] };
      }
      if (!old) {
        old = { values: [] };
      }
      return { young, old };
    },

    scaleAndData(element) {
      const range = this.currentSeriesRange(element);

      const sets = this.currentSets;

      function testMap(x) {
        let young, old, units;
        if (x.young) {
          let v = x.young.values.find(d => d.name == element);
          young = v ? v.value : 0;
          units = v ? v.units : "NA";
        }
        if (x.old) {
          let v = x.old.values.find(d => d.name == element);
          old = v ? v.value : 0;
          units = v ? v.units : "NA";
        }
        return { young, old, units };
      }
      let data = sets.map(testMap);

      let yVals = data.map(x => parseFloat(x.young));
      let oVals = data.map(x => parseFloat(x.old));
      let values = [];
      if (this.pdfBarType === "regular") {
        values = yVals.concat(oVals);

        if (range["Very Low"] && range["Very High"]) {
          values = values.concat([range["Very Low"], range["Very High"]], 0);
        }
        const y = scaleLinear()
          .domain([0, Math.max(...values)])
          .range([0, 400]);
        return { y, range, data };
      } else {
        values.push(range["Very High"] - range["Perfect"]);
        values.push(range["Perfect"] - range["Very Low"]);
        values.push(Math.max(...yVals) - range["Very High"] + values[0]);
        values.push(range["Very Low"] - Math.min(...yVals) + values[1]);
        values.push(Math.max(...oVals) - range["Very High"] + values[0]);
        values.push(range["Very Low"] - Math.min(...oVals) + values[1]);
        values.push(range["Perfect"]);
        values = values.map(x => parseFloat(x));

        const y = scaleLinear()
          .domain([0, Math.max(...values)])
          .range([0, 200]);
        return { y, range, data };
      }
    },

    currentSeriesRange(element) {
      if (!this.allRecords[0]) {
        return {};
      }
      const crop = this.allRecords[0].cropName;
      const ranges = this.getRanges.find(x => x.cropName == crop);
      const elmtRange = {};
      if (ranges) {
        for (let name of ranges.names) {
          elmtRange[name] = ranges[name][element];
        }
      }
      return elmtRange;
    },

    resetOrder() {
      this.elements.sort(dynamicSortNumber("id"));
      this.orderHasChanged = false;
    },

    rows(rowNum) {
      let start = 15;
      let rowPx = 10;
      return rowNum * rowPx + start;
    },

    graphRows(rowNum, x) {
      let start = x === "noHead" ? 53 : 74;
      let rowPx = 37.75;
      return rowNum * rowPx + start;
    },

    infoFromSet(set) {
      let val = {};
      if (set.young && set.young.sampleDate) {
        val = set.young;
      } else if (set.old) {
        val = set.old;
      }
      return `${new Date(val.sampleDate).toLocaleDateString()} - ${val.locationName || ""} - ${val.plotName ||
        ""} - ${val.varietyName || ""} - ${val.cropName || ""}`;
    },

    moonIcon(set) {
      let val = {};
      if (set.young && set.young.sampleDate) {
        val = set.young;
      } else if (set.old) {
        val = set.old;
      }
      return lunarPhaseAndIcon(new Date(val.sampleDate));
    },

    ...mapMutations(["closePage"]),
    ...mapActions(["notify"]),
  },
  computed: {
    computedHeight() {
      let r = 4 / this.currentSets.length;

      const defaults = {
        bar: 3 * r,
        row: 8 * r,
      };

      return defaults;
    },

    currentInfo() {
      if (!this.allRecords || !this.allRecords[0]) {
        return {};
      }
      let address = this.addresses.find(x => x.businessId === this.allRecords[0].businessId);

      if (address && address.address.length > 1) {
        let billing = address.address.find(x => x.type === "billing");
        if (billing) {
          address.address[0] = billing;
        }
      }
      return {
        ...address.address[0],
        businessName: this.allRecords[0].businessName,
        locationName: this.allRecords[0].locationName,
        plotName: this.allRecords[0].plotName,
        cropName: this.allRecords[0].cropName,
        varietyName: this.allRecords[0].varietyName,
      };
    },

    currentSets() {
      let sets = [];
      const setIds = Array.from(new Set(this.allRecords.map(x => x.setId)));
      let index = 0;
      for (let id of setIds) {
        if (!id) {
          continue;
        }
        let vals = this.allRecords.filter(x => x.setId === id);
        let set = this.youngOldSet(vals);

        sets.push(set);
        index++;
        if (index >= 4) {
          break;
        }
      }
      return sets;
    },

    svgLogo() {
      return { logoPath1, logoPath2 };
    },

    activeElements() {
      return this.elements.filter(x => x.active);
    },

    pdfBarType() {
      return this.pdfType.split(" ")[0];
    },

    elementList: {
      get() {
        return this.elements;
      },
      set(list) {
        this.orderHasChanged = true;
        this.elements = list;
      },
    },

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },

    ...mapGetters({
      multiPdf: "multiPdf",
      addresses: "currentAddresses",
      searchResults: "currentSearchResults",
      allRecords: "allRecords",
      getRanges: "getRanges",
    }),
  },
  watch: {
    async multiPdf(value) {
      if (value) {
        await this.$nextTick();
        makeDraggableSvg(this.$el.querySelector("#svg-multi"));
      }
    },
  },
  mounted() {
    EventBus.$on("update-annotations", data => {
      if (data.name === "multi-pdf") {
        this.annotations = data.annotations;
      }
    });
  },
  components: {
    draggable,
    SvgLegend,
    PdfDisclaimer,
    Alert,
    PDFAnnotations,
  },
};
</script>

<style lang="scss" scoped>
.draggable {
  cursor: grab;
}

.pdf-page {
  box-shadow: 0px 0px 5px #484848;
  margin-bottom: 5px;
}

.logo-scale {
  transform: scale(0.3);
}

.pdf-sidebar-outer {
  position: fixed;
  right: 0;
  top: 0;
  width: 20em;
  height: 100%;
}

.pdf-sidebar {
  position: relative;
  padding-top: 3.5em;
  background-color: rgb(253, 247, 239);
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 5px #484848;
}

.pdf-inner {
  position: relative;
  margin: 1em;
  padding-bottom: 4em;
}

.close-settings-icon {
  font-size: 1.8em;
  color: #7a7a7a;
  float: left;
  cursor: pointer;
  margin-top: -0.2em;
  margin-right: -1em;
}

.list-item {
  padding: 0.3em;
  margin: 0.4em;
  background-color: white;
  text-align: left;
  box-shadow: 0px 0px 2px #7a7a7a;
  border-radius: 5px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}
</style>
